<template>
  <div>
    <div>
      <el-transfer
        filterable
        filter-placeholder="请输入"
        :filter-method="filterMethod"
        v-model="value"
        :titles="['所有话题', '已有话题']"
        :data="data"
        @change="getObject">
      </el-transfer>
    </div>
    <div class="text-right" style="margin-top: 10px;">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'topic-edit',
  props: ['row'],
  components: {},
  data () {
    return {
      data: [],
      value: [],
      filterMethod (query, item) {
        return item.label.indexOf(query) > -1
      }
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      let page = await this.$HTTP.ApiTopic.getPageList()
      const data = []
      for (let x = 0; x < page.length; x++) {
        let item = page[x]
        data.push({
          label: item.topicName,
          key: x,
          id: item.id
        })
      }
      this.data = data
      this.value = []
      let list = await this.$HTTP.ApiTopic.getPageList({ categoryId: this.row.id })
      for (let i = 0; i < list.length; i++) {
        const child = this.data.findIndex(el => el.id === list[i].id)
        this.value.push(child)
      }
    },
    async save () {
      let array = this.value.map(el => {
        return this.data[el].id
      })
      let param = {
        topicIdList: array,
        categoryId: this.row.id
      }
      await this.$HTTP.ApiTopic.setCategory(param)
      this.$message({ type: 'success', message: '操作成功' })
      this.$emit('close')
      // }
    },
    // 右侧列表元素变化时触发
    getObject () {
      this.value.map(el => {
        return {
          id: this.data[el].id,
          label: this.data[el].label
        }
      })
    }
  }
}
</script>
